export default {
    colors: {
        primary: '#006eaf',
        secondary: '#59DC87',
        tertiary: '#59A5F4'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.secondary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.tertiary,
        partnerCardMainDiscountColor: colors.tertiary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary,

        buttonMainBg: colors.secondary,
        buttonMainText: colors.white,
        buttonMainBorder: colors.secondary,
        buttonMainHoverBg: colors.secondary,
        buttonMainHoverText: colors.white,
        buttonMainHoverBorder: colors.secondary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/capitalkoalaTheme.js